import classNames from 'classnames';
import moment from 'jalali-moment';
import { StarFilled } from '@ant-design/icons';
import { gold } from '@ant-design/colors';
import { Flex } from '@/components/common';
import { useTranslation } from 'react-i18next';

export interface MessageItemsProps {
  id: string;
  date: string;
  subject: string;
  onClick: (id: string) => void;
  isRead?: boolean;
  important?: boolean;
}

export function MessageItem({
  id,
  date,
  subject,
  onClick,
  isRead = false,
  important = false
}) {

  const [t] = useTranslation(['common']);

  return (
    <Flex
      direction="row"
      align="center"
      onClick={() => onClick(id)}
      className={classNames('message-item', { 'message-item-unread': !isRead })}>
      {important &&
        <Flex
          align="center"
          justify="center"
          style={{ backgroundColor: gold.primary }}
          className="absolute rounded-full p-2 w-[1.5rem] h-[1.5rem] -right-[0.75rem] border-[3px] border-solid border-white">
          <StarFilled style={{ color: '#fff', fontSize: '0.6rem' }} />
        </Flex>
      }
      <Flex className="text-[#4D4D4D] pe-4" inlineFlex>{t('common:labels.announcement')}</Flex>
      <Flex inlineFlex><b>{subject}</b></Flex>
      <Flex className="!ms-auto" inlineFlex>
        {moment.from(date, 'en').format('jYYYY/jMM/jDD')}
      </Flex>
    </Flex>
  );
};

export default MessageItem;
